export default "__VITE_ASSET__313137f3__"